import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  retrieveVehicleBrands,
  retrieveVehicleModels,
  retrieveVehicleChargerTypes,
  createVehicle,
} from "../../actions/commonActions";
import _ from "lodash";
export default function RegisterVehicle({ setAddNewVehicle }) {
  const dispatch = useDispatch();
  const [licensePlate, setLicensePlate] = useState("");
  const [vehicleBrand, setVehicleBrand] = useState("");
  const [vehicleModel, setVehicleModel] = useState("");
  const [vehicleChargerType, setVehicleChargerType] = useState("");
  const [vehicleYear, setVehicleYear] = useState("");

  console.log("details for Initial", { licensePlate, vehicleBrand, vehicleModel, vehicleChargerType, vehicleYear })


  const { vehicleBrands, vehicleModels, vehicleChargerTypes } = useSelector(
    (reduxState) => reduxState.common
  );

  const { driverProfile } = useSelector((reduxState) => reduxState);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!licensePlate || !vehicleBrand || !vehicleModel || !vehicleChargerType || !vehicleYear) {
      return
    }
    createVehicle(
      dispatch,
      driverProfile.driver_id,
      {
        license_plate: licensePlate,
        vehicle_brand_id: vehicleBrand,
        vehicle_model_id: vehicleModel,
        vehicle_charger_type_id: vehicleChargerType,
        vehicle_year: vehicleYear,
      },
      () => {
        setAddNewVehicle(false);
      }
    );

    console.log("details for api", { licensePlate, vehicleBrand, vehicleModel, vehicleChargerType, vehicleYear })
  };

  useEffect(() => {
    console.log("Implimentation 1")
    retrieveVehicleBrands(dispatch);
  }, []);
  useEffect(() => {
    if (vehicleBrand !== "") retrieveVehicleModels(dispatch, vehicleBrand);
  }, [vehicleBrand]);
  useEffect(() => {
    if (vehicleModel !== "")
      retrieveVehicleChargerTypes(dispatch, vehicleModel);
  }, [vehicleModel]);

  return (
    <div className="container">
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <input
            className="form-control my-2"
            placeholder="Vehicle Registration"
            name="licensePlate"
            value={licensePlate}
            onChange={(e) => setLicensePlate(e.target.value)}
          />
          <select
            className="form-control my-2"
            id="vehicleBrand"
            name="vehicleBrand"
            value={vehicleBrand}
            onChange={(e) => setVehicleBrand(e.target.value)}
          >
            <option value="" disabled>
              Vehicle Brand
            </option>
            {vehicleBrands.map((vb) => (
              <option value={vb.vehicle_brand_id}>{vb.name}</option>
            ))}
          </select>
          <select
            className="form-control my-2"
            name="vehicleModel"
            id="vehicleModel"
            value={vehicleModel}
            disabled={vehicleModels.length == 0}
            onChange={(e) => setVehicleModel(e.target.value)}
          >
            <option value="a">Vehicle Model</option>
            {vehicleModels.map((vb) => (
              <option value={vb.vehicle_model_id}>{vb.name}</option>
            ))}
          </select>

          <select
            className="form-control my-2"
            name="vehicleYear"
            value={vehicleYear}
            id="vehicleYear"
            placeholder="Year"
            onChange={(e) => setVehicleYear(e.target.value)}
          >
            <option value="" disabled>
              Year
            </option>
            {_.range(2010, new Date().getFullYear() + 1).map((year) => (
              <option value={year}>{year}</option>
            ))}
          </select>

          <select
            className="form-control my-2"
            name="vehicleChargerType"
            id="vehicleChargerType"
            value={vehicleChargerType}
            disabled={vehicleChargerTypes.length == 0}
            onChange={(e) => setVehicleChargerType(e.target.value)}
          >
            <option value="a">Vehicle Charger type</option>
            {vehicleChargerTypes.map((vct) => (
              <option value={vct.vehicle_charger_type_id}>{vct.name}</option>
            ))}
          </select>
          <button className="btn btn-primary" type="submit" disabled={!vehicleBrand || !vehicleModel || !vehicleYear || !vehicleChargerType}>
            Create
          </button>
        </div>
      </form>
    </div>
  );
}
